export default __webpack_public_path__ + "static/smbIcon-2d0a0231c8582358f8ac0965e9993047.png";